import React, { useEffect, useRef } from "react";
import moment from "moment";
import { func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col, Collapse } from "reactstrap";
import {
  useDispatch,
  useSelector,
  // useDispatch
} from "react-redux";

import { ButtonWithSpinner } from "../../../../../components/common";
import { asyncJobsLoading } from "../../../selectors";

import { LabeledDatePicker, Select } from "../../../../../components/formik";

import {
  asyncJobTypes,
  asyncJobFinished,
  ASYNC_JOBS_INITIAL_FILTERS,
  ASYNC_JOBS_FILTER_LABELS,
  asyncJobResultTypes,
  exportTypes,
} from "../../../constants/asyncJobsConstants";
import "./asyncJobsForm.css";
import {
  getAsyncJobs,
  getAsyncJobsCount,
  selectAsyncJobsFilters,
  setAsyncJobsSearchFilters,
} from "../../../actions/getActions/getAsyncJobsActions";
import Clickable from "../../../../../components/common/Clickable";
import { CollapseButton, CollapseOpenIcon } from "../../../../../assets";
import { FaTimes } from "react-icons/fa";
// import ButtonSelectAsyncJobs from "../../../../../components/formik/async-jobs/ButtonSelectAsyncJobs";
import {
  DATE_WITH_CURRENT_YEAR,
  DATE_WITH_MIN_YEAR,
} from "../../../../../utilities/common";

const AsyncJobsForm = ({
  handleSubmit,
  entries,
  toggleCollapse,
  isOpenCollapse,
  types,
  isExport,
}) => {
  // const scoringTypes = useSelector(scoringResultsReportScoringTypesSelector);
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const isLoading = useSelector(asyncJobsLoading);
  const filters = useSelector(selectAsyncJobsFilters);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getScoringResultsReportScoringTypes());
  // }, []);

  useEffect(() => {
    dispatch(setAsyncJobsSearchFilters(ASYNC_JOBS_INITIAL_FILTERS));
    formikRef.current.setValues(ASYNC_JOBS_INITIAL_FILTERS);
  }, [isExport]);

  useEffect(() => {
    dispatch(setAsyncJobsSearchFilters(ASYNC_JOBS_INITIAL_FILTERS));
    formikRef.current.setValues(ASYNC_JOBS_INITIAL_FILTERS);
  }, [isExport]);

  const indexOfExportFilter = Object.keys(filters).indexOf("export");
  const filtersCopy = { ...filters };
  delete filtersCopy["export"];
  // this is required for the reason of "export" filter that we do not need for UI specifically
  // removing it in a copied object that will be used for UI only will not let it to affect on the logic
  return (
    <Formik onSubmit={handleSubmit} ref={formikRef}>
      {({ errors, values }) => {
        const { dateFrom: dateFromValue, dateTo: dateToValue } = values;
        return (
          <div>
            <div className="async-jobs-search">
              <Collapse isOpen={isOpenCollapse}>
                <Form className="async-jobs-search-form">
                  <Row className="async-jobs-search-form-inner-container">
                    <Col lg={3} className="p-0">
                      <Row>
                        <Col lg={6} className="pr-2">
                          <LabeledDatePicker
                            dateFormat="dd.MM.yyyy"
                            name="dateFrom"
                            placeholderText="Date From"
                            minDate={DATE_WITH_MIN_YEAR}
                            maxDate={
                              dateToValue
                                ? new Date(dateToValue)
                                : DATE_WITH_CURRENT_YEAR
                            }
                            openToDate={new Date(moment())}
                          />
                        </Col>
                        <Col lg={6} className="pl-2">
                          <LabeledDatePicker
                            dateFormat="dd.MM.yyyy"
                            name="dateTo"
                            maxDate={DATE_WITH_CURRENT_YEAR}
                            minDate={
                              dateFromValue
                                ? new Date(dateFromValue).getTime()
                                : DATE_WITH_MIN_YEAR
                            }
                            placeholderText="Date To"
                            openToDate={new Date(moment())}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {/* {isExport ? ( 
                      <Col lg={3}>
                        <Field
                          type="text"
                          name="jobResultType"
                          component={Select}
                          className="dropdown-group"
                          placeholder="Job Result Type"
                          options={asyncJobResultTypes}
                          isClearable
                        />
                      </Col>
                    ) : ( */}
                    <Col lg={3}>
                      <Field
                        type="text"
                        name="jobType"
                        options={types}
                        component={Select}
                        className="dropdown-group"
                        placeholder={
                          isExport ? "Export Type" : "Mass Action Type"
                        }
                        isClearable
                      />
                    </Col>
                    {/* <Col lg={3}>
                      <Field
                        type="text"
                        name="jobResultType"
                        component={Select}
                        className="dropdown-group"
                        placeholder="Job Result Type"
                        options={asyncJobResultTypes}
                        isClearable
                      />
                    </Col> */}
                    {/* <Col lg={3}>
                      <Field
                        type="text"
                        name="finished"
                        component={ButtonSelectAsyncJobs}
                        // className="dropdown-group"
                        label="Status: "
                        options={asyncJobFinished}
                        isClearable
                      />
                    </Col> */}
                  </Row>
                  <Row>
                    <Col lg={8}>
                      {errors.atLeastOneOf && (
                        <React.Fragment>
                          <div className="form-error-message">
                            {errors.atLeastOneOf}
                          </div>
                        </React.Fragment>
                      )}
                    </Col>
                    <Col
                      lg={12}
                      className="pt-4 d-flex justify-content-center "
                    >
                      <ButtonWithSpinner
                        id="asyncJobsSubmitButton"
                        text="Search"
                        type="submit"
                        className="search-button-async-jobs"
                        loading={isLoading}
                      />
                    </Col>
                  </Row>
                </Form>
                <div className="async-jobs-filters-menu-collapse-button">
                  {entries.length ? (
                    <Clickable onClick={toggleCollapse}>
                      <CollapseButton />
                    </Clickable>
                  ) : null}
                </div>
              </Collapse>
            </div>
            <div className="async-jobs-filters-menu-collapse-button">
              <Clickable onClick={toggleCollapse}>
                {!isOpenCollapse ? <CollapseOpenIcon /> : null}
              </Clickable>
            </div>
            <div className="async-jobs-filters-main-container">
              {Object.values(filtersCopy).some(
                (x) => x !== undefined && x !== null && x !== ""
              ) ? (
                <div className="filters-menu-label">Filter Applied</div>
              ) : null}
              {Object.entries(filtersCopy).map(([key, value], i) => {
                if (i === indexOfExportFilter) {
                  return null;
                }
                return value !== undefined && value !== null && value !== "" ? (
                  <SingleFilter
                    filterKey={key}
                    filterValue={value}
                    clearFilter={() => clearSingleFilter(key)}
                  />
                ) : null;
              })}
              {Object.values(filtersCopy).some(
                (x) => x !== undefined && x !== null && x !== ""
              ) ? (
                <div
                  onClick={clearFilters}
                  className="filters-menu-label-clear"
                >
                  Clear All
                </div>
              ) : null}
            </div>
          </div>
        );
      }}
    </Formik>
  );

  function clearFilters() {
    dispatch(setAsyncJobsSearchFilters(ASYNC_JOBS_INITIAL_FILTERS));
    formikRef.current.setValues(ASYNC_JOBS_INITIAL_FILTERS);
    toggleCollapse();
  }

  function clearSingleFilter(filterKey) {
    let val = "";
    const currentFilters = { ...filters };
    dispatch(
      setAsyncJobsSearchFilters({
        [filterKey]: val,
      })
    );
    currentFilters[filterKey] = val;
    formikRef.current.setFieldValue(filterKey, val);
    if (Object.values(currentFilters).filter(Boolean).length) {
      dispatch(getAsyncJobsCount(currentFilters));
      dispatch(getAsyncJobs(currentFilters));
    } else {
      toggleCollapse();
    }
  }

  function SingleFilter({
    filterKey = "",
    filterValue = "",
    clearFilter = () => {},
  }) {
    let currentValue = filterValue;

    if (filterKey === "jobResultType") {
      currentValue = asyncJobResultTypes.find(
        (aj) => aj.value === filterValue
      ).label;
    }

    if (filterKey === "finished") {
      currentValue = asyncJobFinished.find(
        (aj) => aj.value === filterValue
      ).label;
    }

    if (filterKey === "jobType") {
      const fromExpType = exportTypes.find((aj) => aj.value === filterValue);
      const fromJobType = asyncJobTypes.find((aj) => aj.value === filterValue);

      if (fromExpType) {
        currentValue = fromExpType.label;
      }

      if (fromJobType) {
        currentValue = fromJobType.label;
      }
    }

    if ((filterKey === "dateFrom" || filterKey === "dateTo") && filterValue) {
      currentValue = moment(new Date(filterValue)).format("DD.MM.yyyy");
    }

    return (
      <div className="single-filter-box">
        <div className="single-filter-label">
          {ASYNC_JOBS_FILTER_LABELS[filterKey]}
        </div>
        <div className="single-filter-chip">
          {currentValue}
          <FaTimes
            className="remove-filter-icon"
            onClick={clearFilter}
            color="#707070"
          />
        </div>
      </div>
    );
  }
};

AsyncJobsForm.propTypes = {
  handleSubmit: func.isRequired,
};

export default AsyncJobsForm;



// WEBPACK FOOTER //
// ./src/features/organization/pages/async-jobs/async-jobs-form/AsyncJobsForm.jsx